import { getCurrentInstance } from 'vue'

export const usePublicApolloClient = () => {
  const instance = getCurrentInstance()

  // $apolloProvider はプラグイン登録時に設定されるため、setup 内で取得できる。
  const client = instance.proxy.$apolloProvider.clients.publicClient

  return { client }
}
